<template>
  <div class="order-index-page">
    <div class="page-search-block">
      <div class="m-b-18 filter-item">
        <span class="w-90 inline-block align-r m-r-8">订单状态：</span>
        <div>
          <el-button :class="filters.search.orderState==1?'primary':'info'" @click="setSearchOrderState(1)" class="search-field-btn">已预订</el-button>
          <el-button :class="filters.search.orderState==2?'primary':'info'" @click="setSearchOrderState(2)" class="search-field-btn">待入住</el-button>
          <el-button :class="filters.search.orderState==3?'primary':'info'" @click="setSearchOrderState(3)" class="search-field-btn">已入住</el-button>
          <el-button :class="filters.search.orderState==4?'primary':'info'" @click="setSearchOrderState(4)" class="search-field-btn">已完成</el-button>
          <el-button :class="filters.search.orderState==5?'primary':'info'" @click="setSearchOrderState(5)" class="search-field-btn">已取消</el-button>
          <el-button :class="filters.search.orderState==6?'primary':'info'" @click="setSearchOrderState(6)" class="search-field-btn">已失效</el-button>
        </div>
      </div>
      <div class="m-b-18 filter-item">
        <span class="w-90 inline-block align-r m-r-8">预抵日期：</span>
        <div>
          <el-button :class="filters.search.timeType==0?'primary':'info'" @click="setSearchTimeType(0)" class="search-field-btn">不限</el-button>
          <el-button :class="filters.search.timeType==1?'primary':'info'" @click="setSearchTimeType(1)" class="search-field-btn">昨日</el-button>
          <el-button :class="filters.search.timeType==2?'primary':'info'" @click="setSearchTimeType(2)" class="search-field-btn">今日</el-button>
          <el-button :class="filters.search.timeType==3?'primary':'info'" @click="setSearchTimeType(3)" class="search-field-btn">本周</el-button>
          <el-button :class="filters.search.timeType==4?'primary':'info'" @click="setSearchTimeType(4)" class="search-field-btn">自定义</el-button>
        </div>
        <div v-show="filters.search.timeType==4" class="search-time-block">
          <el-date-picker
            style="width:370px;margin-left:5px;"
            v-model="filters.search.searchTimeVal"
            type="datetimerange"
            :unlink-panels="true"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="YYYY-MM-DD HH:mm"
            value-format="YYYY-MM-DD HH:mm"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="search-bar">
        <div class="inline-block">
          <span class="w-90 inline-block align-r m-r-8">订单类型：</span>
          <el-select v-model="filters.search.orderType" class="m-r-8 w-120" clearable >
            <el-option key="typall" value="" label="全部"></el-option>
            <el-option key="typ1" :value="1" label="全日房"></el-option>
            <el-option key="typ2" :value="2" label="钟点房"></el-option>
          </el-select>
        </div>
        <div class="inline-block">
          <span class="w-90 inline-block align-r m-r-8">房型：</span>
          <el-select v-model="filters.search.roomTypeId" class="m-r-8 w-120" filterable placeholder="全部" clearable>
            <el-option key="typall" value="" label="全部"></el-option>
            <el-option v-for="item in selOptions.roomType" :key="item.roomTypeCode"  :label="item.roomTypeName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="inline-block">
          <el-select v-model="filters.search.room" class="select-as-label w-100 m-r-8">
            <el-option key="rom1" value="roomName" label="房源名称"></el-option>
            <el-option key="rom2" value="roomCode" label="房源编码"></el-option>
          </el-select>
          <el-input v-model="filters.search.roomValue" class="w-120" placeholder="请输入" ></el-input>
        </div>
        
        <div class="inline-block">
          <span class="w-90 inline-block align-r m-r-8">订单来源：</span>
          <el-select v-model="filters.search.orderSource" class="m-r-8 w-120"  filterable placeholder="全部" clearable>
            <el-option key="typall" value="" label="全部"></el-option>
            <el-option v-for="item in selOptions.platform" :key="item.platformCode"  :label="item.platformName" :value="item.platformCode">
            </el-option>
          </el-select>
        </div>
        <div class="inline-block">
          <el-select v-model="filters.search.booker" class="select-as-label m-r-8 w-120" >
            <el-option key="rent1" value="bookerName" label="预订人"></el-option>
            <el-option key="rent2" value="bookerPhone" label="预订人电话"></el-option>
          </el-select>
          <el-input v-model="filters.search.bookerValue" class="w-200 m-r-8" placeholder="请输入" ></el-input>
        </div>
        <el-button
          type="primary"
          class="submit-btn"
          size="medium"
          @click="handleQuery"
          >搜 索</el-button
        >
      </div>
    </div>
    <div style="display: flex; justify-content: flex-end; padding-right: 32px; align-items: center;">
      <i class="iconfont show-more" :class="isShowMore ? 'wyf-yanjing_kai' : 'wyf-yanjing_bi'" @click="() => isShowMore = !isShowMore"></i>
      <el-button
        type="warning"
        v-permission="'add'"
        @click="handleEdit('add')"
      >
        录入订单
      </el-button>
      <el-button
        plain
        type="danger"
        v-permission="'relet'"
        :disabled="disabledBtn('relet')"
        @click="handleEdit('checkout')">退房</el-button>
      <el-button
        plain
        type="success"
        v-permission="'relet'"
        @click="handleEdit('extend')">续住</el-button>
      <el-button
        plain
        type="primary"
        v-permission="'changeHouse'"
        :disabled="disabledBtn('changeHouse')"
        @click="handleEdit('changeHouse')">换房</el-button>
      <el-button
        plain
        type="warning"
        v-permission="'reserveAgain'"
        :disabled="disabledBtn('reserveAgain')"
        @click="handleEdit('reserveAgain')">再次预订</el-button>
      <el-button
        plain
        type="primary"
        v-permission="'add'"
        :disabled="multiSelections.length !== 1 || [3, 4, 5, 6].indexOf(filters.search.orderState) !== -1"
        @click="handleEarlyCheckin">提前入住</el-button>
      <el-button
        plain
        type="primary"
        :disabled="
          multiSelections.length != 1 ||
          ![2, 3].includes(multiSelections[0].orderState) ||
          !multiSelections[0].deviceCode
        "
        v-permission="'makeCard'"
        @click="makeCard">制卡
      </el-button>
    </div>
   
    <div class="page-operate-block">
       <!--  v-permission="'add'" -->
      <!-- <div class="tit">订单列表</div> -->
    </div>
    <div class="table-list-block" v-loading="saveLoading">
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column align="center" width="55px" prop="ddd">
          <template #header>
            <el-checkbox v-model="isSelectAll"></el-checkbox>
          </template>
          <template #default="{row}">
            <el-checkbox v-model="row.isChecked" @change="handleSelectionChange(row)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="orderCode" label="订单编号" width="200">
          <template #default="{row}">
            <a @click="handleRowEdit(row,'show')">{{row.orderCode}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="orderTypeName" label="订单类型" width="100"/>
        <el-table-column prop="orderSourceName" label="订单来源" width="100"/>
        <el-table-column label="预订人">
          <template #default="{row}">
            {{isShowMore ? row.bookerName : filterName(row.bookerName)}}
          </template>
        </el-table-column>
        <el-table-column prop="bookerPhone" label="预订人电话" width="120">
          <template #default="{row}">
            {{isShowMore ? row.bookerPhone : filterPhone(row.bookerPhone)}}
          </template>
        </el-table-column>
        <el-table-column prop="roomTypeId" label="房型" width="120">
          <template #default="{row}">
            {{selOptionMaps.roomType[row.roomTypeId]}}
          </template>
        </el-table-column>
        <el-table-column prop="roomName" label="房源名称" width="100"/>
        <el-table-column prop="orderPrice" label="房费"/>
        <el-table-column align="left" width="300px">
          <template #header>
            <div>（预）抵离时间</div>
          </template>
          <template #default="scope">
            <div class="order-time-block">
              <div>
                <div><span class="order-time-label-1">抵</span>{{(scope.row.orderState==3 || scope.row.orderState==4) ? scope.row.actualCheckInTime:scope.row.proposedCheckInTime}}</div>
                <div><span class="order-time-label-2">离</span>{{(scope.row.orderState==4) ? scope.row.actualCheckOutTime:scope.row.proposedCheckOutTime}}</div>
              </div>
              <div class="order-timestr-block">
                共{{ getDiffTimeStr(scope.row)}}
              </div>
            </div>
          </template>
        </el-table-column>  
        <el-table-column prop="createTime" label="预订时间" width="200"/>
        <el-table-column label="操作" width="160">
          <template #default="scope">
            <div style="display: flex;">
              <el-button
                v-permission="'update'"
                :disabled="!(scope.row.orderState == 1 || scope.row.orderState == 2 || scope.row.orderState == 3)"
                @click="handleRowEdit(scope.row,'edit')"
                type="text"
              >修改</el-button>
              <el-button
                v-permission="'cancel'"
                :disabled="!(scope.row.orderState == 1 || scope.row.orderState == 2)"
                @click="handleRowEdit(scope.row,'cancel')"
                type="text"
              >取消</el-button>
              <el-button
                v-permission="'checkOut'"
                :disabled="!(scope.row.orderState == 3)"
                @click="handleRowEdit(scope.row,'checkout')"
                type="text"
              >退房</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <RPagination :pagination="pagination" @current-change="handlePageChange"/>
    </div>
    <!--查看-->
    <RModal :title="modalTitles[detailType]" v-model="detailModal" top="3vh" :closeOnClick="false" @change="detailModal = false" @close="closeModel" width="1000px">
      <template #content>
        <detail-view
          v-if="detailType=='show'"
          :detailData="detailData"
          :selOptions="selOptions"
          :detailModal="detailModal"
          :hiddenNumberBol="hiddenNumberBol"
          @submitSuccess="submitSuccess"
          @handleRowEdit="handleRowEdit" />

        <edit-view
          v-else-if="detailType == 'add' || detailType == 'edit' || detailType == 'reserveAgain'"
          :detailType="detailType"
          :detailData="detailData"
          :selOptions="selOptions"
          :detailModal="detailModal"
          :selMapsWyfbm="selOptionMaps.rooms"
          @submitSuccess="submitSuccess"
          @closeModel="closeModel" />

        <cancel-view
          v-else-if="detailType == 'cancel'"
          :detailType="detailType"
          :detailData="detailData"
          :selOptions="selOptions"
          :detailModal="detailModal"
          @submitSuccess="submitSuccess"
          @closeModel="closeModel" />

        <extend-view
          v-else-if="detailType == 'extend'"
          :detailType="detailType"
          :detailData="detailData"
          :selOptions="selOptions"
          :detailModal="detailModal"
          @submitSuccess="submitSuccess"
          @closeModel="closeModel" />

        <change-house-view
          v-else-if="detailType == 'changeHouse'"
          :detailType="detailType"
          :detailData="detailData"
          :selOptions="selOptions"
          :detailModal="detailModal"
          @submitSuccess="submitSuccess"
          @closeModel="closeModel" />

        <check-out-view
          v-else-if="detailType == 'checkout'"
          :detailType="detailType"
          :detailData="detailData"
          :selOptions="selOptions"
          :detailModal="detailModal"
          @submitSuccess="submitSuccess"
          @closeModel="closeModel" />
      </template>
    </RModal>

    <RModal
      v-model="cardModal"
      width="800px"
      title="制卡"
      :closeOnClick="false"
      @change="cardModal = false"
      @close="cardModal = false">
      <template #content>
        <CardView :show="earlyCheckinModal" :form-data="detailData" @cancel="earlyCheckinModal = false" @success="handleEarlyCheckSuccess" />
      </template>
    </RModal>
    <RModal
      v-model="earlyCheckinModal"
      width="800px"
      title="办理提前入住"
      :closeOnClick="false"
      @change="earlyCheckinModal = false"
      @close="earlyCheckinModal = false">
      <template #content>
        <EarlyCheckinView :show="earlyCheckinModal" :form-data="detailData" @cancel="earlyCheckinModal = false" @success="handleEarlyCheckSuccess" />
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import RPagination from '@/components/common/RPagination'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from '@/components/common/checkAll.js'
import orderMix from './mixin.js'
import detailView from './detailView'
import editView from './editView'
import cancelView from './cancelView'
import extendView from './extendView'
import changeHouseView from './changeHouseView'
import { reactive, ref } from 'vue'
import checkOutView from '@/views/baseInfo/order/checkOutView' 
import moment from 'moment'
import EarlyCheckinView from './earlyCheckinView.vue'
import CardView from './cardView.vue'

export default {
  name: 'employeeIndex',
  mixins: [tableMix, checkMix, orderMix],
  components: { RTable ,RPagination,detailView,RModal,editView,cancelView,extendView,checkOutView,changeHouseView, EarlyCheckinView, CardView },
  data() {
    let day = moment().startOf('day').format('YYYY-MM-DD HH:mm')
    let endDay = moment().subtract(-7, 'days').endOf('day').format('YYYY-MM-DD HH:mm')
    let timeVal = ref([
      day,
      endDay,
    ])
    let searchData = {'orderSource':'','orderState':1,'timeType':0,'orderType':'','roomCode':'','roomName':'',
    'booker':'bookerName','bookerName':'','bookerPhone':'','bookerValue':'',
    'room':'roomName','roomCode':'','roomName':'','roomValue':'','roomTypeId':'',
    searchTimeVal:timeVal,proposedCheckInStartTime:'',proposedCheckInEndTime:''}

    return {
      isShowMore: false,
      //detailType=='show'?'详情':(detailType=='edit'?'编辑':(detailType=='checkout'?'办理退房':'新增'
      modalTitles:{add:'新增',edit:'变更',check:'审核',show:'详情',copy:'复制',bind:'绑定',checkout:'办理退房','extend':'续住','changeHouse':'换房','reserveAgain':'再次预订'},
      perms: [],
      orderStateMap:{'1':'已预订','2':'已登记','3':'已入住','4':'已完成','5':'已取消','6':'已失效'},
      //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效
      activeSubName:'2',
      detailModal:false,
      detailType:'show',
      uploadModal:false,
      downloadUrl:'',
      detailData:{},
      deleteUrl:'SAAS.ORDER_DELETE',
      areUOk: false,
      tableVarity: 'baseinfo_order',
      tableColumn: [],
      tableData: [],
      selOptions:{certType:[],rooms:[],roomType:[],platform:[],orderType:[{code:1,name:'全日房'},{code:2,name:'钟点房'}]},
      selOptionMaps:{rooms:{},roomType:{},platform:{},orderType:{1:'全日房',2:'钟点房'}},
      options: {
        multiSelect: false, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        height: 'calc(100vh - 375px)',
        mutiSelect: false,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: { search: {...searchData} },
      filtersInitSearchData:{...searchData},//重置时使用
      hiddenNumberBol: true,
      isIndeterminate:false,
      multiSelections:[],//id
      tempSelections: [],
      rowCheckedAll:false,
      saveLoading:false,
      managerList: [], // 已通过经营者

      earlyCheckinModal: false,
      cardModal: false,
    }
  },
  created() {
    this.$eventBus.on('change-shop', store => {
      this.$nextTick(()=>{
        this.handleQuery()
        this.getDictData()
      })
    })
    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    this.initTableColumns()
    this.getDictData()
    this.getDataList(false)
  },
  computed: {
    disabledBtn() {
      let func = type => {
        switch(type) {
          case 'relet':
            return !(
              this.multiSelections.length == 1 &&
              this.multiSelections[0].orderState == 3 &&
              this.multiSelections[0].orderType == 1
            )
          case 'changeHouse':
            return !(
              this.multiSelections.length == 1 &&
              (
                this.multiSelections[0].orderState == 3 ||
                this.multiSelections[0].orderState == 2 ||
                this.multiSelections[0].orderState == 1
              )
            )
          case 'reserveAgain':
            return !(
              this.multiSelections.length == 1 && 
              (
                this.multiSelections[0].orderState == 4 ||
                this.multiSelections[0].orderState == 5 ||
                this.multiSelections[0].orderState == 6
              )
            )
        }
      }
      return func
    },
    isSelectAll:{
      get(){
        return this.tableData.every(e => e.isChecked);
      },
      set(val){
        this.tableData.forEach(e => {
          e.isChecked = reactive(val);
        });
      }
    }
  },
  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },
  beforeRouteLeave(){
    this.$eventBus.off('change-shop')
  },
  mounted() {
    let curOrderPageTab = localStorage.getItem('curOrderPageTab')
    if (curOrderPageTab != null) {
      this.activeSubName = curOrderPageTab
      this.$nextTick(() => {
        setTimeout(() => {
          this.getDataList()
        }, 300);
      })
    }
  },
  methods: {
    async makeCard(){
      try {
        const order = this.multiSelections[0];
        const checkInPersonInfoDTOS = await this.getDetailInfo(order.id).then(
          ({data}) => data.checkInPersonInfoDTOS.filter(e => e.verificationStatus == 2)
        );
        if(!checkInPersonInfoDTOS.length) return this.$message.error('该订单无已认证租客');
        order.checkInPersonInfoDTOS = checkInPersonInfoDTOS;
        await this.fetchData({
          url: 'SAAS.ORDERINFO_GETCARDTOTAL',
          method: 'get',
          params: {orderCode: order.orderCode},
        }).then((res) => {
          order.cardTotal = res;
          this.detailData = order;
        })
        this.cardModal = true;
      } catch (error) {
        this.$message.error("操作失败");
      }
    },
    //数据选择
    handleSelectionChange(order) {
      // 莫名其妙，不知道为什么前两次点击 checkbox 不修改isChecked
      if (order.isChecked === order.checkOld) {
        order.isChecked = !order.isChecked
      }
      order.checkOld = order.isChecked

      let checked = []
      this.tableData.length && this.tableData.forEach((item)=>{
        item.isChecked && checked.push({...item})
      })
      this.multiSelections = checked

      this.rowCheckedAll = this.multiSelections.length == this.tableData.length ? true : false
      this.isIndeterminate = (this.multiSelections.length && this.multiSelections.length != this.tableData.length) ? true : false
    },

    //数据全选
    handleSelectAllChange(val){
      this.multiSelections = false
      let checked = []
      this.tableData.length && this.tableData.forEach((item)=>{
        item.isChecked = val
        if(val){
          checked.push({...item})
        }
      })
      
      this.multiSelections = checked
    },

    // 获取字典数据
    getDictData() {
      let url= ''
      //房源
      let params = {reviewStatus:2,pageNumber: 1,pageSize: 99999999}
      let curStoreInfo = this.getCurStoreInfo()
      if(curStoreInfo && curStoreInfo.id){
        params['storeId'] = curStoreInfo.id
      }
      this.fetchData({
        url:'SAAS.ROOM_LIST',
        method: 'get',
        params
      }).then( res => {
        let maps = {}
        let rooms = []
        res.data.map((obj)=>{
          maps[obj.id] = {roomName:obj.roomName,roomCode:obj.roomCode,id:obj.id}
          rooms.push({roomName:obj.roomName,roomCode:obj.roomCode,id:obj.id,roomTypeId:obj.roomTypeId})
        })
        this.selOptions.rooms = rooms
        this.selOptionMaps.rooms = maps
      })

      //房型
      params = {pageNumber: 1,pageSize: 99999999}
      curStoreInfo = this.getCurStoreInfo()
      if(curStoreInfo && curStoreInfo.id){
        params['storeId'] = curStoreInfo.id
      }

      url = 'SAAS.ROOM_TYPE_LIST'
      this.fetchData({
        url,
        method: 'get',
        params,
      }).then((res) => {
        this.selOptions.roomType = res.data || []
        let roomTypeMap = {}
        res.data && res.data.length && res.data.forEach((item)=>{
          roomTypeMap[item.id] = item.roomTypeName
        })
        this.selOptionMaps.roomType = roomTypeMap

      })
      .catch((err) => {
        console.log(err, 'errorInfo')
      })

      //平台
      params = {params:'{}'}
      url = 'SAAS.ROOM_PLATEFORM'
      this.fetchData({
        url,
        method: 'get',
        params,
      }).then((res) => {
        this.selOptions.platform = res.data || []
        let map = {}
        res.data && res.data.length && res.data.forEach((item)=>{
          map[item.platformCode] = item.platformName
        })
        this.selOptionMaps.platform = map

      })
      .catch((err) => {
        console.log(err, 'errorInfo')
      })

      //证件类型
      url = 'RESOURCE.QUERY_DICTS_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: {
          types: 'certType'
        },
        flag:true
      }).then( res => {
        if(!res || res.code!=200){
          return false
        }
        this.selOptions.certType = res.data['certType'] || []
      }).catch((err) => {
        console.log(err, 'errorInfo')
      })
    },

    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryListParams()
      if(params.room && params.roomValue){
        params[params.room] = params.roomValue
      }

      if(params.booker && params.bookerValue){
        params[params.booker] = params.bookerValue
      }
      if(params.timeType==4){
        params.proposedCheckInStartTime = params.searchTimeVal[0]
        params.proposedCheckInEndTime = params.searchTimeVal[1]
      }

      let curStoreInfo = this.getCurStoreInfo()
      if(curStoreInfo && curStoreInfo.id){
        params['storeId'] = curStoreInfo.id
      }

      delete params.room
      delete params.roomValue
      delete params.booker
      delete params.bookerValue
      delete params.timeType
      delete params.searchTimeVal
      
      this.saveLoading = true
      let url = 'SAAS.ORDER_QUERY_LIST'
      this.fetchData({
        url,
        method: 'get',
        params,
      })
        .then((res) => {
          this.options.loading = false
          this.rowCheckedAll = false
          if (this.toExcel == true) {
            if (!res || !res.data) {
              this.$message.error('操作失败！')
            } else {
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }
          
          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            res.data.forEach(item => {
              item.isChecked = false
              item.checkOld = false
            })
            this.tableData = res.data || [];
            this.pagination.total = res.rowCount;
            this.hiddenNumberBol = true;
          }
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
          this.saveLoading = false
        })
    },
    //相差几晚,1-全日房，2-钟点房
    getDiffTimeStr(row){
      let start = (row.orderState==3 || row.orderState==4) ? row.actualCheckInTime:row.proposedCheckInTime
      let end = (row.orderState==4) ? row.actualCheckOutTime:row.proposedCheckOutTime
      let timeStr = this.getDiffTime(start,end,row.orderType)
      return timeStr+(row.orderType==2?'小时':'晚')
    },
   
    // 初始化自定义表头
    initTableColumns() {
      // 表头 visible：默认可见；isInput：表头是否输入框；isSelect：表头是否下拉框
      let columns = [
        { prop: 'orderCode', label: '订单编号', visible: true, minWidth: 160, isInput: true },
        { prop: 'orderType', label: '订单类型', visible: true, minWidth: 160, isInput: true },
        { prop: 'orderSourceName', label: '订单来源', visible: true, minWidth: 160, isInput: true },
        { prop: 'bookerName', label: '预订人', visible: true, minWidth: 100, isInput: true },
        { prop: 'bookerPhone', label: '预订人电话', visible: true, minWidth: 160, isInput: true },
        { prop: 'roomTypeName', label: '房型', visible: true, minWidth: 160, isInput: true },
        { prop: 'roomName', label: '房源名称', visible: true, minWidth: 160, isInput: true  },
        { prop: 'proposedCheckInTime', label: '抵离时间', visible: true, minWidth: 160, isInput: true },
        { prop: 'createTime', label: '预订时间', visible: true, minWidth: 160, isInput: true  },
        { prop: 'operation', align:'center',label: '操作', visible: true, minWidth: 200, isInput: false },
      ]

      columns.forEach((item) => {
        if(item.prop=='orderCode'){
          item.render =  (row, index, column)=>{
            return <a  onClick={this.handleRowEdit.bind(this, row,'show')}>{row[column.prop]}</a>;
          }
        }else if(item.prop=='orderType'){
          item.render =  (row, index, column)=>{
            return <span>{this.selOptionMaps.orderType[row['orderType']]}</span>;
          }
        }else if(item.prop=='proposedCheckInTime'){
          item.render =  (row, index, column)=>{
            let start = (row.orderState==3 || row.orderState==4) ? row.actualCheckInTime:row.proposedCheckInTime
            let end = (row.orderState==4) ? row.actualCheckOutTime:row.proposedCheckOutTime
            return (
              <div>
                <div>抵：{start}</div>
                <div>离：{end}</div>
              </div>
            );
            
          }
        }else if(item.prop=='operation'){
          //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效。目前房东没有退房权限
          item.render =  (row, index, column)=>{
            let editFlag = (row.orderState==1 || row.orderState==2 || row.orderState==3) ? true:false
            let cancelFlag = (row.orderState==1 || row.orderState==2) ? true:false
            let checkoutFlag = row.orderState==3 ? true:false

            
            return (
              <div class="operation">
                <el-button
                    v-permission="update"
                    disabled={!editFlag}
                    style="margin-left: 10px"
                    onClick={this.handleRowEdit.bind(this, row,'edit')}
                    style="padding: 0; margin-left:20px"
                    type="text"
                >修改</el-button>
                <el-button
                    v-permission="cancel"
                    disabled={!cancelFlag}
                    style="margin-left: 10px"
                    onClick={this.handleRowEdit.bind(this, row,'cancel')}
                    style="padding: 0; margin-left:20px"
                    type="text"
                >取消</el-button>
                <el-button
                    v-permission="checkOut"
                    disabled={!checkoutFlag}
                    style="margin-left: 10px"
                    onClick={this.handleRowEdit.bind(this, row,'checkout')}
                    style="padding: 0; margin-left:20px"
                    type="text"
                >退房</el-button>
              </div>
            );
          }
        }

        if(item.prop=='proposedCheckInTime'){
          item.label = (this.filters.search.orderState*1==3 || this.filters.search.orderState*1==4) ? '抵离时间':'预抵离时间'
        }
      })
      //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效。目前房东没有退房权限
      this.tableColumn = [...columns]
    },

    //获取详情信息
    async getDetailInfo(id,detailType){
      let url = 'SAAS.ORDER_QUERY_DETAIL'
      let params = {id:id}
      let detailInfo  = await this.fetchData({
        url,
        method: 'get',
        params,
        flag:true
      })
      return detailInfo
    },
    //顶部编辑
    handleEdit(detailType){
      // 若为 “录入订单” 操作，先判断是否存在房型，若不存在，则直接给出提示
      if(detailType === 'add') {
        if(!this.selOptions.roomType.length) {
          this.$message.warning('请先添加至少一种房型！')
          return false
        }
      }

      this.detailType = detailType
      const operates = ['edit','show','cancel','extend','changeHouse','reserveAgain']
      
      if(operates.indexOf(detailType)>-1 && this.multiSelections.length){
        let sel = this.multiSelections[0]
        let detailInfo = this.getDetailInfo(sel.id,'show').then((res)=>{
          this.detailData = res.data || []
          this.$nextTick(()=>{
            this.detailModal = true
          })
        }).catch((err)=>{
          console.log(err,'err======')
        })
      }else{
        this.detailData = {}
        this.$nextTick(()=>{
          this.detailModal = true
        })
      }
    },
    //行修改、行取消、行退房
    handleRowEdit(row,detailType){
      this.detailType = detailType
      if(detailType=='checkout'){
        this.detailData = {...row}
        this.$nextTick(()=>{
          this.detailModal = true
        })
      }else if(detailType=='cancel'){
        this.$confirm('该操作是不可恢复的，是否取消订单!', { type: 'warning' }).then(() => {
          this.doCancelSave(row)
        }).catch((err) => {
          console.log(err,'========00')
        })
      }else if(detailType=='edit' || detailType=='show'){
        let detailInfo = this.getDetailInfo(row.id,'show').then((res)=>{
          this.detailData = {...res.data} || []
          this.$nextTick(()=>{
            this.detailModal = true
          })
        }).catch((err)=>{
          console.log(err,'err======')
        })
      }
    },
    //行取消-保存
    doCancelSave(row){
      
      let url = 'SAAS.ORDER_EDIT_CANCEL'
      let params = {id:row.id}

      this.fetchData({url:url, method: 'post', params:params,timeout:0, isLoading:false, flag:true}).then((res)=>{
        if(res.code==200){
          this.$message.success(res.msg||'操作成功！')
          this.submitSuccess()
        }else{
          this.$message.error(res.msg||'操作失败！')
        }
      }).catch((err)=>{
        console.log(err,'========00')
        this.$message.error('操作失败！')
      }).finally (()=>{
      })
    },
    
    submitSuccess(){
      this.detailModal=false
      this.detailType = ''
      this.handleQuery()
    },
    closeModel(){
      this.detailModal=false
    },
    //设置查询类型
    setSearchTimeType(val){
      this.filters.search.timeType = val
      let day = ''
      let endDay = ''
      switch(val){
        case 0:
          this.filters.search.proposedCheckInStartTime = ''
          this.filters.search.proposedCheckInEndTime = ''
          break
        case 1: 
          day = moment().subtract(1, 'days').format('YYYY-MM-DD')
         // console.log(day,'dddd',moment().subtract(1, 'days').format('YYYY-MM-DD') ,moment().subtract(1, 'days').toString() )
          this.filters.search.proposedCheckInStartTime = day +' 00:00:00'
          this.filters.search.proposedCheckInEndTime = day +' 23:59:59'
          break
        case 2:
          day = moment().format('YYYY-MM-DD')
          this.filters.search.proposedCheckInStartTime = day +' 00:00:00'
          this.filters.search.proposedCheckInEndTime = day +' 23:59:59'
          break
        case 3:  
          day = moment().week(moment().week()).startOf('week').format('YYYY-MM-DD'); 
          endDay = moment().week(moment().week()).endOf('week').format('YYYY-MM-DD'); 
          this.filters.search.proposedCheckInStartTime = day +' 00:00:00'
          this.filters.search.proposedCheckInEndTime = endDay +' 23:59:59'
          break
        case 4:
          day = moment().startOf('day').format('YYYY-MM-DD HH:mm')
          endDay = moment().subtract(-7, 'days').endOf('day').format('YYYY-MM-DD HH:mm')
          let timeVal = ref([
            day,
            endDay,
          ])
          this.filters.search.searchTimeVal = timeVal
      }
      this.handleQuery()
    },
    //设置状态查询
    setSearchOrderState(val){
      this.filters.search.orderState = val
      this.initTableColumns()
      this.handleQuery()
    },
    // 处理提前入住
    handleEarlyCheckin() {
      let order = this.multiSelections[0]
      if (order.orderType == 2) {
        return this.$message.warning('钟点房无法提前入住')
      }
      this.getDetailInfo(order.id).then(res => {
        this.detailData = res.data || []
        this.$nextTick(() => {
          this.earlyCheckinModal = true
        })
      })
    },
    // 处理提前入住操作成功
    handleEarlyCheckSuccess() {
      this.cardModal = false
      this.handleQuery()
    },
    // 处理表格刷新
    handleQuery() {
      this.multiSelections = []
      this.handleSearch()
    },
    filterName(name){
      if(name && name.length){
        const len = name.length;
        if(len == 1){
          return name;
        }else if(len == 2){
          return name[0] + '*';
        }else{
          return name[0] + new Array(len - 2).fill("*").join('') + name[len - 1]
        }
      }else{
        return name;
      }
    },
    filterPhone(phone){
      return phone.slice(0, 3) + "****" + phone.slice(7);
    }
  }
}
</script>
<style lang="less" scoped>
.show-more{
  font-size: 20px;
  cursor: pointer;
  margin-right: 8px;
}
.order-index-page{
  padding-bottom: 5px;
  background-color: white;
  border-radius: 8px;
}
.filter-item{
  display: flex;
  align-items: center;
}
.search-bar{
  display: flex;
  align-items: center;
}
.primary{
  background-color: #FCBF0C !important;
  color: white;
}
.search-field-btn {
  // margin-right: 8px;
  background-color: white;
  border: 1px solid #DCDFE6;
  border-right: none;
  border-radius: 0;
  &:first-child{
    border-radius: 4px 0 0 4px;
  }
  &:last-child{
    border-right: 1px solid #DCDFE6;
    border-radius: 0 4px 4px 0;
  }
}
.table-list-block{
  padding: 16px;
}
.log-title {
  font-size: 22px;
  font-weight: 600;
}
.el-form-item.rowItem {
  width: 100% !important;
}
.page-search-block .el-button + .el-button {
    margin-left: 0;
}
.roomSel{
  /deep/ .el-input__inner{
    border: none;
  }
}
.bookerSel{
  /deep/ .el-input__inner{
    border: none;
    text-align: right;
    padding-right: 30px;
  }
}

#detailModalId {
  /deep/ .modal-dialog {
    top: 20%;
  }
}
.orderDetailModalDialog{
  /deep/ .modal-dialog {
    top: 0px !important;
  }
  /deep/ .modal-content{
    max-height: 85vh !important;
    margin-top: 10vh !important;
    overflow: hidden;
  }
  /deep/ .modal-dialog .modal-content .modal-body{
    height: calc(~'(85vh - 70px)') !important;
    overflow: auto;
  }
}
/* 表格样式 */
.top-table :deep(.el-table__empty-block){
  height: 1px !important;
  min-height: 1px !important;
}
.tables-block{
  width: 100%;
  max-height: calc(~"100vh - 480px");
  overflow-y: scroll;
}
.tables-block .el-table{
  border:1px solid #ddd !important;
  border-radius: 2px;
  margin-top: 14px;
}
.tables-block .el-table :deep(.el-table__body .el-checkbox){
  height: 1px !important;
  overflow: hidden;
}
.tables-block .el-table :deep(th){
  font-weight: normal !important;
  font-size: 12px;
  background: #f3f6fc;
}
.search-time-block{
  display: inline-block;
  vertical-align: bottom;
}
.order-type-text{
  font-size: 14px;
  color: #00c0c0;
  font-weight: bold;
}
.order-time-block{
  display: flex;
  align-items: center;
}
.order-timestr-block{
  margin-left: 20px;
}
.order-time-label-1,.order-time-label-2{
  padding: 3px;
  width:22px;
  height:22px;
  background-color:#52b82f;
  border-radius:5px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  margin-right: 20px;
}
.order-time-label-2{
  background-color:#fe4d4d;
}

/* 可以提为公共样式 */
.table-btn {
  padding: 0px;
  margin: 0px 5px;
  color: #00c0c0;
  border: unset;
  cursor: pointer;
}
.table-btn.is-disabled {
  color: var(--el-button-disabled-text-color);
}
</style>
<style lang="less">
.el-table{
  border-top: 1px solid #DCDFE6;
  border-left: 1px solid #DCDFE6;
  border-right: 1px solid #DCDFE6;
}
.el-table th.el-table__cell{
  background-color: #F2F6FC;
  border-right: 1px solid #DCDFE6;
  &:last-child{
    border-right: none;
  }
}
.el-table td.el-table__cell{
  &:last-child{
    border-right: none;
  }
  border-right: 1px solid #DCDFE6;
  // border-left: 1px solid #DCDFE6;
}
</style>